import { Loader } from "@googlemaps/js-api-loader"
import { imageUrlBase } from "../../utils"

// constants
const API_KEY = 'AIzaSyBgOO2mVtMpExJzVH973YlqPVBGBQ7hTQk';
const MAP_ID = 'a901bf1b78a9c72d';
const KIOSK = window.SD_KIOSK;
const MAP_HTML_ID = 'map';

// logic
window.addEventListener('load', function(){
  if (KIOSK) {
    const location = KIOSK;
    location.gpsLatitude = parseFloat(location.gpsLatitude)
    location.gpsLongitude = parseFloat(location.gpsLongitude)

    const loader = new Loader({
      apiKey: API_KEY,
      mapId: MAP_ID,
      version: "weekly",
    });
    
    loader.load().then((google) => {
      const map = new google.maps.Map(document.getElementById(MAP_HTML_ID), {
        center: {
          lat: location.gpsLatitude,
          lng: location.gpsLongitude
        },
        zoom: 14,
        mapTypeControl: false,
        fullScreenControl: false,
        streetViewControl: false,
      });
  

      new google.maps.Marker({
        map,
        title: location.name,
        position: {
          lat: parseFloat(location.gpsLatitude),
          lng: parseFloat(location.gpsLongitude)
        },
        icon: {
          url: `${imageUrlBase}/location-pin.png`, 
          scaledSize: new google.maps.Size(36, 44) 
        }
      });
    });
  }
})